import { useMutation, useQuery } from '@apollo/react-hooks';
import { Layout } from 'components/Layout/Layout';
import withApollo from 'lib/apollo';
import { useUnauthenticatedOnlyRoute } from 'lib/hooks/useUnauthenticatedOnlyRoute';
import React, { useState } from 'react';
import { RegisterForm } from '../components/Authentication/Forms/RegisterForm';
import { PublicLayout } from '../components/Layout/PublicLayout';
import gql from 'graphql-tag';
import dynamic from 'next/dynamic';
import { publicClient } from 'application/middleware/ekardo/ekardoClient';

const GET_USEFLOW_TRACKING = gql`
  query {
    userFlowStepTrack {
      latestTracking(userFlowStepId: 145) {
        answers {
          contentSnippetQuestionId
          ... on QuestionAnswerRadioType {
            questionResponseRadioId
          }
        }
      }
    }
  }
`;

const NoSSRContentWrapper = dynamic(() => import('../components/ContentUI/NoSSRComp'), {
  ssr: false,
});
function RegisterPage() {
  useUnauthenticatedOnlyRoute();
  const [isRecommended, setIsRecommended] = useState(false);

  const { data } = useQuery(GET_USEFLOW_TRACKING, {
    client: publicClient,
    onCompleted: (data) => {
      const answer = data?.userFlowStepTrack?.latestTracking?.answers?.find((answer) => answer.contentSnippetQuestionId === 14489);
      if (answer && answer.questionResponseRadioId === 1227) {
        setIsRecommended(true);
      } else {
        setIsRecommended(false);
      }
    },
  });
  return (
    <Layout title="Sign up">
      <PublicLayout
        header={() => (
          <div>
            <img className="m-b" src="/images/icon-register.svg" />
            <h1 className="h-color--white h-font--uppercase">
              Sign up with <br />
              <span style={{ color: 'var(--pale)' }}>Crystal</span>
              <span style={{ color: 'var(--pale)', fontWeight: 100 }}>clear</span>
            </h1>
            <p className="h-color--white">Please fill out the information to create your account</p>
            {isRecommended && (
              <p className="h-color--white" style={{width:'25rem',marginTop:'30px'}}>
                <strong>Thank you for completing the quiz based on your results we believe you would benefit from
                taking part in the Crystal Clear program</strong>
              </p>
            )}
          </div>
        )}
      >
        <RegisterForm />
      </PublicLayout>
    </Layout>
  );
}

export default withApollo(RegisterPage, { ssr: false });
